module.exports = __webpack_public_path__ + "static/media/next_page.cd87a0e3.svg";